// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"DateNavigation_navWrapper__PzhFT","inactive":"DateNavigation_inactive__6zSv5"};